module.exports = __webpack_public_path__ + "img/phone-icon.b7bf6c8b.svg";